import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Texture, BaseTexture, settings, Ticker, UPDATE_PRIORITY } from '@pixi/core';
import { Container } from '@pixi/display';
import { Text, TextStyle, TextMetrics } from '@pixi/text';
import { CountLimiter } from './CountLimiter.mjs';
function findMultipleBaseTextures(item, queue) {
  var _item$_textures;
  var result = false;
  if (item !== null && item !== void 0 && (_item$_textures = item._textures) !== null && _item$_textures !== void 0 && _item$_textures.length) {
    for (var i = 0; i < item._textures.length; i++) {
      if (item._textures[i] instanceof Texture) {
        var baseTexture = item._textures[i].baseTexture;
        if (!queue.includes(baseTexture)) {
          queue.push(baseTexture);
          result = true;
        }
      }
    }
  }
  return result;
}
function findBaseTexture(item, queue) {
  if (item.baseTexture instanceof BaseTexture) {
    var texture = item.baseTexture;
    if (!queue.includes(texture)) {
      queue.push(texture);
    }
    return true;
  }
  return false;
}
function findTexture(item, queue) {
  if (item._texture && item._texture instanceof Texture) {
    var texture = item._texture.baseTexture;
    if (!queue.includes(texture)) {
      queue.push(texture);
    }
    return true;
  }
  return false;
}
function drawText(_helper, item) {
  if (item instanceof Text) {
    item.updateText(true);
    return true;
  }
  return false;
}
function calculateTextStyle(_helper, item) {
  if (item instanceof TextStyle) {
    var font = item.toFontString();
    TextMetrics.measureFont(font);
    return true;
  }
  return false;
}
function findText(item, queue) {
  if (item instanceof Text) {
    if (!queue.includes(item.style)) {
      queue.push(item.style);
    }
    if (!queue.includes(item)) {
      queue.push(item);
    }
    var texture = item._texture.baseTexture;
    if (!queue.includes(texture)) {
      queue.push(texture);
    }
    return true;
  }
  return false;
}
function findTextStyle(item, queue) {
  if (item instanceof TextStyle) {
    if (!queue.includes(item)) {
      queue.push(item);
    }
    return true;
  }
  return false;
}
var BasePrepare = /*#__PURE__*/function () {
  function BasePrepare(renderer) {
    var _this = this;
    _classCallCheck(this, BasePrepare);
    this.limiter = new CountLimiter(settings.UPLOADS_PER_FRAME);
    this.renderer = renderer;
    this.uploadHookHelper = null;
    this.queue = [];
    this.addHooks = [];
    this.uploadHooks = [];
    this.completes = [];
    this.ticking = false;
    this.delayedTick = function () {
      if (!_this.queue) {
        return;
      }
      _this.prepareItems();
    };
    this.registerFindHook(findText);
    this.registerFindHook(findTextStyle);
    this.registerFindHook(findMultipleBaseTextures);
    this.registerFindHook(findBaseTexture);
    this.registerFindHook(findTexture);
    this.registerUploadHook(drawText);
    this.registerUploadHook(calculateTextStyle);
  }
  _createClass(BasePrepare, [{
    key: "upload",
    value: function upload(item) {
      var _this2 = this;
      return new Promise(function (resolve) {
        if (item) {
          _this2.add(item);
        }
        if (_this2.queue.length) {
          _this2.completes.push(resolve);
          if (!_this2.ticking) {
            _this2.ticking = true;
            Ticker.system.addOnce(_this2.tick, _this2, UPDATE_PRIORITY.UTILITY);
          }
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "tick",
    value: function tick() {
      setTimeout(this.delayedTick, 0);
    }
  }, {
    key: "prepareItems",
    value: function prepareItems() {
      this.limiter.beginFrame();
      while (this.queue.length && this.limiter.allowedToUpload()) {
        var item = this.queue[0];
        var uploaded = false;
        if (item && !item._destroyed) {
          for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
            if (this.uploadHooks[i](this.uploadHookHelper, item)) {
              this.queue.shift();
              uploaded = true;
              break;
            }
          }
        }
        if (!uploaded) {
          this.queue.shift();
        }
      }
      if (!this.queue.length) {
        this.ticking = false;
        var completes = this.completes.slice(0);
        this.completes.length = 0;
        for (var _i = 0, _len = completes.length; _i < _len; _i++) {
          completes[_i]();
        }
      } else {
        Ticker.system.addOnce(this.tick, this, UPDATE_PRIORITY.UTILITY);
      }
    }
  }, {
    key: "registerFindHook",
    value: function registerFindHook(addHook) {
      if (addHook) {
        this.addHooks.push(addHook);
      }
      return this;
    }
  }, {
    key: "registerUploadHook",
    value: function registerUploadHook(uploadHook) {
      if (uploadHook) {
        this.uploadHooks.push(uploadHook);
      }
      return this;
    }
  }, {
    key: "add",
    value: function add(item) {
      for (var i = 0, len = this.addHooks.length; i < len; i++) {
        if (this.addHooks[i](item, this.queue)) {
          break;
        }
      }
      if (item instanceof Container) {
        for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
          this.add(item.children[_i2]);
        }
      }
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.ticking) {
        Ticker.system.remove(this.tick, this);
      }
      this.ticking = false;
      this.addHooks = null;
      this.uploadHooks = null;
      this.renderer = null;
      this.completes = null;
      this.queue = null;
      this.limiter = null;
      this.uploadHookHelper = null;
    }
  }]);
  return BasePrepare;
}();
export { BasePrepare };